import {AfterViewInit, Component, OnDestroy, OnInit, ViewChild, Input} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient, HttpParams} from "@angular/common/http";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {MatLegacyPaginator as MatPaginator} from "@angular/material/legacy-paginator";
import {ContactDepartmentFilter} from "./contactDepartment.filter";
import {debounceTime} from "rxjs/operators";
import {SettingsPersistenceService} from "../services/settings-persistence.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-contactDepartments',
  templateUrl: './contactDepartments.component.html'
})
export class ContactDepartmentsComponent implements OnInit, OnDestroy, AfterViewInit  {

  @Input()
  contactCompanyId:any;

  @Input()
  companyId:any;

  dataSource:MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns:string[] = ['name'];
  filter:ContactDepartmentFilter = new ContactDepartmentFilter();

  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;

  pageSettings: SettingsPersistenceService;
  isCompanyAdmin: boolean;
  isEmbedded: boolean;

  constructor(public auth: AuthService,
              private env: EnvService,
              private http: HttpClient) {
  }

  ngOnInit() {
    this.isCompanyAdmin = this.auth.isCompanyAdmin();
    this.isEmbedded = !!this.contactCompanyId;
    if (this.isCompanyAdmin) {
      this.companyId = this.companyId || this.auth.companyIdFilter || undefined;
    } else {
      this.companyId = this.auth.getCompanyId();
    }
  }

  ngAfterViewInit() {
    this.pageSettings = new SettingsPersistenceService(sessionStorage, "micro.contactDepartments");
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .setEmbedded(this.isEmbedded)
      .init();

    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    this.reload();
  }

  ngOnDestroy() {
  }

  reload() {
    let params:HttpParams;
    if (this.contactCompanyId) {
      params = new HttpParams()
        .set('contactCompanyId', this.contactCompanyId);
    } else {
      params = this.filter.getParams()
        .set("page", '' + (this.paginator.pageIndex || 0))
        .set("size", '' + (this.paginator.pageSize || this.pageSettings.defaultPageSize));
    }

    this.http.get(`${this.env.e.url}/auth/contactDepartments`, {params:params}).subscribe(
      data => {
        let page = data as any;
        this.dataSource.data = page.content;
        this.paginator.pageIndex = page.number;
        this.paginator.pageSize = page.size;
        this.paginator.length = page.totalElements;
      }
    );
  }
}
